
import {useState, useEffect  } from "react";


import { Spinner, Flex, AlertIcon, AlertDescription, FormLabel, Alert,useColorModeValue } from '@chakra-ui/react'; 

import {
  Select,
} from "chakra-react-select";


import InputField from "components/fields/InputField";

import { useQuery  } from "react-query";

import service from 'services/estadosCuentaService';

import { NO_RESULT, TIME_CACHE_LONG, NO_SELECTED } from "const/CommonConst";
import { useEstadoCuentaStore } from 'store/estadoCuentaStore';

export default function EstadosCuentaTipoSelect(props: {
	disabled?: Boolean;
}) {
  const TITLE = 'Tipo de Documento'
  const KEY_FILTER = "estadoCuentaTipoSelect";
	const textColorPrimary = useColorModeValue('secondaryGray.900', 'white');

  const compañia = useEstadoCuentaStore(state => state.compañia)
  const cliente = useEstadoCuentaStore(state => state.cliente)
	const tipoDocumento = useEstadoCuentaStore(state => state.tipoDocumento)
  const updateTipoDocumento = useEstadoCuentaStore(state => state.updateTipoDocumento)
  
  const [codigoCliente, setCodigoCliente] = useState('');
  const [codigoCompañia, setCodigoCompañia] = useState('');

  const fetchData = async (filtroCliente, filtroCompañia) => {

    const tempData = await service.getTiposEstadoCuenta(filtroCliente, filtroCompañia);

    if (tempData.length > 0) {
      updateTipoDocumento(tempData[0].id);
    }

    return tempData;
  };

  const { status, data, error, isIdle } = useQuery({
    queryKey: [KEY_FILTER, codigoCliente, codigoCompañia],
    queryFn: () => fetchData(codigoCliente, codigoCompañia),
    staleTime: TIME_CACHE_LONG,
    enabled: codigoCliente !== '' && codigoCompañia !== ''
},[codigoCliente, codigoCompañia])

useEffect(() => {
  setCodigoCliente(cliente)
  setCodigoCompañia(compañia)
},[cliente, compañia]);


  if (status === "loading" || isIdle) {
    return (
      <Flex direction='column'>
      <FormLabel
        ms='10px'
        htmlFor={KEY_FILTER}
        fontSize='sm'
        color={textColorPrimary}
        fontWeight='bold'
        _hover={{ cursor: 'pointer' }}>
        {TITLE}
      </FormLabel>
      <Spinner
          thickness='4px'
          speed='0.65s'
          emptyColor='gray.200'
          color='blue.500'
          size='md'
        />
        </Flex>
    );
  }    

  if (status === "error") {
    return (
    <Flex direction='column'>
    <FormLabel
      ms='10px'
      htmlFor={KEY_FILTER}
      fontSize='sm'
      color={textColorPrimary}
      fontWeight='bold'
      _hover={{ cursor: 'pointer' }}>
      {TITLE}
    </FormLabel><Alert status='error'>
    <AlertIcon />
    <AlertDescription>{error.message}</AlertDescription>
  </Alert>
        </Flex>);
  }
  
  if (data.length === 0){
      return (
      <Flex direction='column'>
      <FormLabel
        ms='10px'
        htmlFor='client'
        fontSize='sm'
        color={textColorPrimary}
        fontWeight='bold'
        _hover={{ cursor: 'pointer' }}>
        {TITLE}
      </FormLabel><Alert status='info'>
      <AlertIcon />
      <AlertDescription>{NO_RESULT}</AlertDescription>
    </Alert>
        </Flex>);
  }

  const options = data.map(item => {
    return { value: item.id, label: item.name };
  });

 if (options.length <= 1 || props.disabled){
  const defaultSelection = options[0];
  
  return (
    <InputField mb='0px' me='30px' id={KEY_FILTER} label={TITLE} value={defaultSelection.label} isDisabled={true} />
  );
 }


	return (
		<Flex direction='column'>
							<FormLabel
								ms='10px'
								htmlFor={KEY_FILTER}
								fontSize='sm'
								color={textColorPrimary}
								fontWeight='bold'
								_hover={{ cursor: 'pointer' }}>
								{TITLE}
							</FormLabel>
    <Select
								fontSize='sm'
								id={KEY_FILTER}
								variant='main'
								h='44px'
								maxH='44px'
								me='20px'
                placeholder={NO_SELECTED}
								defaultValue={
                  tipoDocumento != ''
                    ? options.filter((r) => r.value == tipoDocumento)
                    : options[0]
                }
                options={options}
                onChange={(selected) => updateTipoDocumento(selected.value)}
                />
                </Flex>
	);
}